export class EquationsTreeNode {
  children?: EquationsTreeNode[];
  name: string;
  value: any;
}
